import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as FlowIconImage } from '../../images/flow-icon.svg';

export const FlowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={FlowIconImage} />
);

export default FlowIcon;
